/**
 * Swatch PDP — in-page tab panels (no navigation on tab click).
 */
function initSwatchProductTabs() {
  document.querySelectorAll('[data-swatch-product-tabs]').forEach(function (root) {
    if (root.dataset.swatchTabsBound === '1') return;
    root.dataset.swatchTabsBound = '1';

    var tabButtons = root.querySelectorAll('[data-swatch-tab]');
    var panels = root.querySelectorAll('[data-swatch-panel]');

    if (!tabButtons.length || !panels.length) return;

    function activateTab(tabId) {
      tabButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-swatch-tab') === tabId;
        var tabItem = button.closest('.swatch-product-tabs__tab');

        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (tabItem) {
          tabItem.classList.toggle('active', isActive);
        }
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-swatch-panel') === tabId;
        panel.classList.toggle('hidden', !isActive);
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var tabId = button.getAttribute('data-swatch-tab');
        if (!tabId) return;
        activateTab(tabId);
      });
    });

    var defaultTab = root.getAttribute('data-default-tab');
    if (defaultTab) {
      activateTab(defaultTab);
    }
  });
}

document.addEventListener('DOMContentLoaded', initSwatchProductTabs);
document.addEventListener('swup:page:view', initSwatchProductTabs);
